import React, { Component } from 'react'
import { Table } from 'react-bootstrap'
import Api from './../../../Global/Modules/Api'

class Bijeenkomsten extends Component {
    constructor(props) {
        super(props)
        this.getMeetings = this.getMeetings.bind(this)
        this.getTotalPoints = this.getTotalPoints.bind(this)
    }

    getMeetings() {
        let data = this.props.data
        return data && data.length > 0 ? data.map((l, index) => {
            return <tr key={index}>
                <td>{l.name}</td>
                <td>{l.city}</td>
                <td>{l.date}</td>
                <td>{l.institution}</td>
                <td>{l.hours}</td>
                <td>{l.points}</td>
            </tr>
        }) : null
    }

    getTotalPoints() {
        let data = this.props.data
        return data && data.length > 0 ?
            <tr>
                <td colSpan='6'><strong>Totaal ke´s</strong></td>
                <td><strong>{data.map(t => { return t.points }).reduce((acc, val) => acc + val)}</strong></td>
            </tr> : null
    }

    render() {
        return (
            <div className="rapport">
                <h5><strong>{this.props.permanent ? "Permanente bijeenkomsten" : "Bijeenkomsten"}</strong></h5>
                <Table responsive bordered className="bijeenkomsten">
                    <thead>
                        <tr>
                            <th>Naam</th>
                            <th>Plaats</th>
                            <th>Datum</th>
                            <th>Organisator</th>
                            <th>Uren</th>
                            <th>Ke's</th>
                        </tr>
                    </thead>

                    <tbody>
                        {this.getMeetings()}
                        {this.getTotalPoints()}
                    </tbody>
                </Table>
            </div>)

    }
}

export default Bijeenkomsten


// WEBPACK FOOTER //
// ./src/components/Member/Modules/Rapport/Bijeenkomsten.js